module.exports = __webpack_public_path__ + "img/plus2.487abd23.svg";